var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ForecastingManagement',{attrs:{"routePlantId":_vm.plantId,"routeProductCategoryId":_vm.productCategoryId,"routeCropLocationId":_vm.cropLocationId,"routeVarietyId":_vm.varietyId,"routeForecastMode":_vm.forecastMode}})}
var staticRenderFns = []

export { render, staticRenderFns }